export const translations = {
  it: {
    "brand.tagline": "Assistente AI per preventivi, fatture e giornate di lavoro",
    "nav.dashboard": "Cruscotto",
    "nav.quotes": "Preventivi",
    "nav.invoices": "Fatture",
    "nav.reminders": "Solleciti",
    "nav.recurring": "Ricorrenti",
    "rec.hint":
      "Le fatture che si ripetono le emette Operativo, da sola. Parti da una fattura già fatta: aprila nell'elenco Fatture e premi l'icona con le due frecce.",
    "rec.empty": "Nessuna fattura ricorrente. Creane una da una fattura esistente:",
    "rec.frequency": "Ogni",
    "rec.next": "Prossima",
    "rec.count": "Emesse",
    "rec.autoSend": "Invio al cliente",
    "rec.runNow": "Emetti adesso",
    "rec.pause": "Metti in pausa",
    "rec.resume": "Riattiva",
    "rec.issued": "Emessa",
    "rec.deleted": "Ricorrenza eliminata",
    "rec.created": "Fattura resa ricorrente: ogni mese la emetto io",
    "rec.makeRecurring": "Rendi ricorrente",
    "rec.weekly": "settimana",
    "rec.monthly": "mese",
    "rec.quarterly": "trimestre",
    "rec.yearly": "anno",
    "wa.send": "Manda su WhatsApp",
    "wa.message": "Ecco il documento",
    "imp.title": "Importa da un altro gestionale",
    "imp.hint":
      "Carica le tue fatture elettroniche XML (anche uno ZIP intero): ricostruisco clienti e storico, così non ricominci da zero.",
    "imp.choose": "Scegli il file XML o ZIP",
    "imp.done": "Importate {n} fatture e {c} clienti",
    "acc.title": "Il tuo commercialista",
    "acc.hint":
      "Ogni mese gli mando io un unico pacchetto con PDF, XML e riepilogo dei documenti emessi. Niente più email a mano a fine mese.",
    "acc.email": "Email del commercialista",
    "acc.day": "Giorno del mese",
    "acc.auto": "Invio automatico ogni mese",
    "acc.sendNow": "Manda ora il mese scorso",
    "acc.sent": "Inviati {n} documenti del mese {m}",
    "common.reload": "Aggiorna",
    "nav.clients": "Clienti",
    "nav.agenda": "Agenda",
    "nav.memory": "Memoria",
    "nav.settings": "Impostazioni",
    "nav.launch": "Lancio",
    "nav.leadFinder": "Trova clienti",
    "nav.admin": "Pannello admin",
    "admin.title": "Pannello di controllo",
    "admin.subtitle": "Tutti i numeri dell'app, in sola lettura. Visibile solo a te.",
    "admin.tab.overview": "Panoramica",
    "admin.tab.users": "Utenti",
    "admin.tab.reservations": "Prenotazioni",
    "admin.tab.payments": "Pagamenti",
    "admin.tab.usage": "Utilizzo",
    "admin.users": "Utenti registrati",
    "admin.last30": "negli ultimi 30 giorni",
    "admin.active7": "attivi 7 giorni",
    "admin.reserved": "Posti prenotati",
    "admin.waitlist": "in waitlist",
    "admin.revenue": "Incassato totale",
    "admin.aiMonth": "Azioni AI del mese",
    "admin.documents": "Documenti creati",
    "admin.quotes": "Preventivi",
    "admin.invoices": "fatture",
    "admin.clients": "Clienti nel sistema",
    "admin.mode": "Modalita' vendita",
    "admin.modePrebook": "Pre-lancio",
    "admin.modeLive": "Pagamenti attivi",
    "admin.emailOn": "Email configurate",
    "admin.emailOff": "Email NON configurate",
    "admin.rows": "righe",
    "admin.exportCsv": "Esporta CSV",
    "admin.empty": "Ancora nessun dato.",
    "admin.usage30": "Documenti creati negli ultimi 30 giorni",
    "admin.notifyNote": "Ricevi una email immediata a ogni registrazione, prenotazione e pagamento.",
    "admin.funnel": "Imbuto di conversione (30 giorni)",
    "admin.chainTitle": "Dove perdo la gente (30 giorni)",
    "admin.chainHint":
      "Ogni passo mostra quante persone lo superano: la barra rossa è il punto dove ne perdi di più.",
    "admin.step.visitors": "Visitatori",
    "admin.step.demo_view": "Sono arrivati alla demo",
    "admin.step.demo": "Hanno provato la demo",
    "admin.step.memory_modal": "Hanno visto la memoria",
    "admin.step.emails": "Hanno lasciato l'email",
    "admin.step.signups": "Hanno aperto l'account",
    "admin.step.activated": "Hanno creato un documento",
    "admin.step.reserved": "Hanno prenotato",
    "admin.ofPrev": "del passo prima",
    "admin.lostHere": "persone perse qui",
    "admin.biggestDrop": "la perdita più grande",
    "admin.activation": "Usano il prodotto",
    "admin.activationHint": "di chi ha aperto l'account ha creato almeno un documento",
    "admin.signupRate": "Registrazioni",
    "admin.reserveRate": "Prenotazioni",
    "admin.sources": "Da dove arrivano (30 giorni)",
    "admin.sourcesHint":
      "Sorgente del primo accesso. Usa link con ?utm_source=instagram per distinguere le campagne.",
    "admin.noSources": "Ancora nessun dato sulle sorgenti.",
    "admin.visitors": "Visitatori unici",
    "admin.views": "visite totali",
    "admin.signups": "Registrazioni",
    "admin.ofVisitors": "dei visitatori",
    "admin.today": "Oggi",
    "admin.col.email": "Email",
    "admin.col.plan": "Piano",
    "admin.col.docs": "Documenti",
    "admin.col.ai": "AI mese",
    "admin.col.seat": "Posto",
    "admin.col.created": "Registrato",
    "admin.col.lastLogin": "Ultimo accesso",
    "admin.col.source": "Origine",
    "admin.col.reserved": "Prenotato il",
    "admin.col.converted": "Registrato il",
    "admin.col.product": "Prodotto",
    "admin.col.amount": "Importo",
    "admin.col.status": "Stato",
    "launch.title": "Cruscotto di lancio",
    "launch.subtitle": "Waitlist, pass di lancio venduti e consumo AI del mese. Visibile solo a te.",
    "launch.waitlist": "Iscritti waitlist",
    "launch.converted": "diventati utenti",
    "launch.passSold": "Pass di lancio venduti",
    "launch.gross": "lordo",
    "launch.proSubs": "abbonati Pro",
    "launch.users": "Utenti registrati",
    "launch.aiActions": "azioni AI questo mese",
    "launch.seats": "Posti offerta di lancio",
    "launch.seatsHint": "posti rimasti",
    "launch.months": "mesi",
    "launch.costs": "I tuoi costi",
    "launch.error": "Solo l'amministratore puo' vedere questi dati.",
    "launch.cost1": "App online su Emergent: 50 crediti al mese fissi (~9,50 EUR), anche senza utenti.",
    "launch.cost2": "Universal Key (AI): solo a consumo, ~0,30-1 EUR al mese per utente attivo.",
    "launch.cost3": "Stripe: ~1,75 USD su ogni pass da 49,90 USD, ~1,15 USD su ogni Pro mensile.",
    "nav.document": "Documento",
    "nav.logout": "Esci",
    "nav.aiAssistant": "Assistente AI",

    "nav.plan": "Abbonamento",
    "plan.current": "Piano attuale",
    "plan.usage": "Documenti creati questo mese",
    "plan.docsMonth": "al mese",
    "plan.trialing": "in prova gratuita",
    "plan.renews": "Rinnovo il",
    "plan.perMonth": "/ mese",
    "plan.trial": "7 giorni di prova gratuita, poi 14,90 € al mese. Disdici quando vuoi.",
    "plan.afterPrice": "Dopo i primi 6 mesi: {price} al mese, prezzo bloccato per sempre. Documenti illimitati.",
    "plan.cta": "Inizia la prova gratuita",
    "plan.ctaYear": "Passa all'annuale",
    "plan.year": "/ anno",
    "plan.yearName": "Pro annuale",
    "plan.yearSave": "Risparmi il 28% rispetto al mensile.",
    "plan.active": "Abbonamento attivo. Grazie!",
    "plan.testCard": "Test: carta 4242 4242 4242 4242, scadenza futura, CVC qualsiasi.",
    "plan.b1": "Preventivi e fatture illimitati",
    "plan.b2": "PDF con logo e IBAN",
    "plan.b3": "Assistente AI e bozze automatiche (fair use 300 azioni/mese sul pass di lancio, più eventuale bonus)",
    "plan.b4": "Solleciti automatici e invio email",
    "plan.b5": "Report incassi e export CSV",
    "plan.manage": "Gestisci o disdici abbonamento",
    "plan.founderBadge": "Offerta di lancio",
    "plan.passName": "Pass di lancio · 6 mesi",
    "plan.passDesc": "Paghi una volta e usi Operativo Pro per 6 mesi. Nessun rinnovo automatico: alla scadenza decidi tu.",
    "plan.passCta": "Prendi il pass di lancio",
    "plan.passActive": "pass di lancio attivo",
    "plan.passExpires": "Scade il",
    "plan.passDaysLeft": "giorni rimasti",
    "plan.passNoRenewal": "Nessun rinnovo automatico: alla scadenza non ti addebitiamo nulla e l'account torna al piano Free.",
    "plan.prebookBadge": "Pre-lancio · posti limitati",
    "plan.prebookText": "Prenota il tuo posto: blocchi il prezzo di 49,90 € per 6 mesi e i +20 crediti AI al mese a vita. Oggi non paghi nulla, ti avvisiamo per email all'apertura dei pagamenti.",
    "plan.prebookNote": "Nel frattempo la beta è gratuita: documenti e PDF illimitati, 30 azioni AI al mese.",
    "plan.trialDaysLeft": "giorni di prova rimasti (tutto attivo, 100 azioni AI)",
    "plan.reserveCta": "Prenota il mio posto",
    "plan.reserveDone": "Posto prenotato! Prezzo bloccato e bonus AI assegnato.",
    "plan.seatNo": "Posto",
    "plan.oneTime": "una volta · 6 mesi",
    "plan.seatsLeft": "posti rimasti",
    "plan.soldOut": "Posti esauriti",
    "plan.fairUse": "Fair use: 300 azioni AI al mese. Documenti, PDF ed email restano illimitati.",
    "plan.guarantee": "Garanzia 30 giorni soddisfatti o rimborsati.",
    "plan.proName": "Pro mensile",
    "plan.aiUsage": "Azioni AI usate",
    "plan.aiMonth": "questo mese",
    "plan.waitlistBonus": "bonus waitlist a vita",
    "plan.manageHint": "Apre il portale Stripe: metodi di pagamento, fatture e disdetta.",
    "pwa.title": "Installa Operativo sul telefono",
    "pwa.text": "Un tap e hai l'app sulla schermata home: preventivi anche mentre sei dal cliente.",
    "pwa.iosSteps": "Su iPhone si installa in 2 tap: apri il menu Condividi di Safari, poi scegli \"Aggiungi alla schermata Home\".",
    "pwa.iosShare": "Condividi → Aggiungi a Home",
    "pwa.settingsHint": "Installa Operativo come app sul telefono o sul computer: si apre a tutto schermo, senza barra del browser. Su iPhone usa Condividi → Aggiungi alla schermata Home.",
    "pwa.cta": "Installa",
    "pwa.later": "Piu' tardi",
    "pay.checking": "Verifico il pagamento…",
    "pay.successTitle": "Pagamento completato",
    "pay.successText": "Il piano Pro è attivo: documenti illimitati e tutte le funzioni AI.",
    "pay.pendingTitle": "Pagamento in verifica",
    "pay.pendingText": "Sto ancora attendendo la conferma. Se hai completato il pagamento, il piano si attiverà a breve.",
    "pay.cancelTitle": "Pagamento annullato",
    "pay.cancelText": "Nessun addebito effettuato. Puoi riprovare quando vuoi.",
    "pay.back": "Torna all'abbonamento",
    "nav.report": "Report",
    "report.invoiced": "Fatturato",
    "report.collected": "Incassato",
    "report.outstanding": "Da incassare",
    "report.byMonth": "Andamento per mese",
    "report.month": "Mese",
    "report.csv": "Esporta CSV",
    "common.loading": "Caricamento…",
    "common.save": "Salva",
    "common.cancel": "Annulla",
    "common.delete": "Elimina",
    "common.add": "Aggiungi",
    "common.search": "Cerca",
    "common.actions": "Azioni",
    "common.status": "Stato",
    "common.date": "Data",
    "common.due": "Scadenza",
    "common.total": "Totale",
    "common.subtotal": "Subtotale",
    "common.notes": "Note",
    "common.client": "Cliente",
    "common.number": "Numero",
    "common.amount": "Importo",
    "common.email": "Email",
    "common.phone": "Telefono",
    "common.address": "Indirizzo",
    "common.vatId": "P. IVA / Codice Fiscale",

    "login.title": "Bentornato",
    "login.subtitle": "Accedi per riprendere da dove hai lasciato.",
    "login.submit": "Accedi",
    "login.noAccount": "Non hai un account?",
    "login.register": "Registrati",
    "login.password": "Password",
    "auth.heroTitle": "Preventivi, fatture e giornate organizzate. Senza perdere tempo.",
    "auth.heroText":
      "Un assistente AI che conosce i tuoi clienti, ricorda il lavoro svolto e produce documenti pronti da inviare in PDF.",
    "register.title": "Crea il tuo spazio",
    "register.subtitle": "Due minuti e hai il tuo assistente operativo.",
    "register.name": "Nome e cognome",
    "register.company": "Azienda / Studio",
    "register.password": "Password (min 6 caratteri)",
    "register.submit": "Crea account",
    "register.hasAccount": "Hai già un account?",
    "register.login": "Accedi",

    "dash.revenue": "Fatturato emesso",
    "dash.pending": "Da incassare",
    "dash.openQuotes": "Preventivi aperti",
    "dash.totalSuffix": "totali",
    "dash.clients": "Clienti",
    "dash.inRegistry": "in anagrafica",
    "dash.tasksToday": "Attività di oggi",
    "dash.completed": "completate",
    "dash.invoicesIssued": "Fatture emesse",
    "dash.quickActions": "Azioni rapide",
    "dash.newQuote": "Nuovo preventivo",
    "dash.newInvoice": "Nuova fattura",
    "dash.addClient": "Aggiungi cliente",
    "dash.planDay": "Pianifica giornata",
    "dash.recentMemory": "Memoria recente",
    "time.title": "Tempo che ti ho fatto risparmiare",
    "time.subtitle": "Stima prudente, calcolata su quello che hai fatto davvero nell'app.",
    "time.thisMonth": "Questo mese",
    "time.hours": "ore",
    "time.sixMonths": "Ultimi 6 mesi",
    "time.each": "min a testa",
    "time.empty": "Ancora niente da contare questo mese: crea un documento e torna qui.",
    "time.documents": "Preventivi e fatture create",
    "time.ai_docs": "Scritte dall'AI (tempo extra)",
    "time.recurring": "Fatture ricorrenti automatiche",
    "time.xml": "Fatture elettroniche XML",
    "time.reminders": "Solleciti inviati",
    "time.notes": "Note salvate in memoria",

    "dash.seeAll": "Vedi tutto",
    "dash.noActivity": "Nessuna attività registrata finora.",
    "dash.firstTitle": "Non hai ancora nessun documento",
    "dash.firstText": "Racconta un lavoro che fai davvero e il tuo primo preventivo è pronto in 20 secondi, voci e prezzi compresi.",
    "dash.firstCta": "Crea il primo preventivo",
    "admin.tab.feedback": "Feedback",
    "admin.feedbackTitle": "Perché non si sono iscritti",
    "admin.feedbackSent": "sondaggi inviati",
    "admin.feedbackEmpty": "Ancora nessuna risposta al sondaggio.",
    "admin.col.received": "Ricevuto il",
    "admin.requestsTitle": "Richieste dei professionisti",
    "dash.overdueOne": "fattura non incassata oltre 30 giorni",
    "dash.overdueMany": "fatture non incassate oltre 30 giorni",
    "dash.toRecover": "da recuperare",
    "dash.generateReminders": "Genera solleciti con l'AI",

    "clients.searchPlaceholder": "Cerca cliente…",
    "clients.new": "Nuovo cliente",
    "clients.edit": "Modifica cliente",
    "clients.name": "Ragione sociale / Nome",
    "clients.empty": "Nessun cliente in anagrafica.",
    "clients.created": "Cliente creato",
    "clients.updated": "Cliente aggiornato",
    "clients.deleted": "Cliente eliminato",
    "clients.deleteTitle": "Eliminare il cliente?",
    "clients.deleteHint": "L'operazione non si puo' annullare. Stai eliminando",

    "docs.countQuotes": "preventivi",
    "docs.countInvoices": "fatture",
    "docs.newQuote": "Nuovo preventivo",
    "docs.newInvoice": "Nuova fattura",
    "docs.empty": "Nessun documento. Creane uno o chiedi all'assistente AI.",
    "docs.downloadPdf": "Scarica PDF",
    "docs.convert": "Converti in fattura",
    "docs.converted": "Fattura creata",
    "docs.deleted": "Documento eliminato",
    "docs.type": "Tipo",
    "docs.quote": "Preventivo",
    "docs.invoice": "Fattura",
    "docs.creditNote": "Nota di credito",
    "docs.proforma": "Pro forma",
    "docs.receipt": "Ricevuta",
    "docs.makeCreditNote": "Crea nota di credito",
    "docs.unit": "unità",
    "docs.discount": "Sconto %",
    "docs.discountShort": "Sc. %",
    "docs.qty": "Q.tà",
    "docs.price": "Prezzo",
    "docs.cassa": "Cassa previdenziale",
    "docs.taxable": "Imponibile",
    "docs.withholding": "Ritenuta d'acconto",
    "docs.stamp": "Marca da bollo",
    "docs.netToPay": "Netto a pagare",
    "docs.fiscalTitle": "Fiscalità professionale",
    "docs.cassaRate": "Cassa %",
    "docs.withholdingRate": "Ritenuta %",
    "docs.withholdingOnCassa": "Applica la ritenuta anche sulla cassa",
    "docs.refNumber": "Fattura di riferimento",
    "settings.fiscalTitle": "Fiscalità professionale",
    "settings.fiscalHint":
      "Questi valori vengono precompilati in ogni nuovo documento. Se non sai cosa mettere, chiedi al tuo commercialista.",
    "settings.defaultCassa": "Cassa previdenziale predefinita %",
    "settings.defaultWithholding": "Ritenuta d'acconto predefinita %",
    "settings.defaultStamp": "Marca da bollo predefinita €",
    "settings.cassaType": "Cassa di appartenenza",
    "settings.withholdingType": "Tipo di ritenuta",
    "docs.freeClient": "— cliente libero —",
    "docs.clientName": "Nome cliente",
    "docs.items": "Voci",
    "docs.description": "Descrizione",
    "docs.saveDoc": "Salva documento",
    "docs.updated": "Documento aggiornato",
    "docs.vatRate": "Imposta %",
    "docs.aiTitle": "Genera con l'AI",
    "docs.aiHint":
      "Es. \"Restyling sito web 8 pagine per Rossi Srl, con SEO e hosting annuale\"",
    "docs.aiPlaceholder": "Descrivi il lavoro…",
    "docs.aiFill": "Compila voci",
    "docs.aiDone": "Bozza generata dall'AI",
    "docs.aiEmpty": "L'AI non ha prodotto voci. Riprova con una descrizione più dettagliata.",
    "docs.aiNeedBrief": "Descrivi il lavoro da preventivare",

    "agenda.task": "Attività",
    "agenda.taskPlaceholder": "Es. Chiamare Rossi per il preventivo",
    "agenda.priority": "Priorità",
    "agenda.high": "Alta",
    "agenda.medium": "Media",
    "agenda.low": "Bassa",
    "agenda.minutes": "Minuti",
    "agenda.empty": "Nessuna attività per questa data.",
    "agenda.aiTitle": "Piano AI della giornata",
    "agenda.aiHint": "Ordina le attività per impatto su incassi e scadenze.",
    "agenda.planNow": "Pianifica ora",
    "agenda.planned": "Giornata pianificata",
    "agenda.planFailed": "Pianificazione non riuscita",

    "memory.notePlaceholder":
      "Registra cosa hai fatto: es. sopralluogo cantiere Bianchi, 2 ore",
    "memory.register": "Registra",
    "memory.searchPlaceholder": "Cerca nella memoria del lavoro svolto…",
    "memory.empty": "Nessun elemento in memoria.",
    "memory.noteSaved": "Nota salvata in memoria",
    "memory.all": "Tutto",
    "memory.notes": "Note",

    "rem.toRecover": "Da recuperare",
    "rem.overdueOne": "fattura non incassata oltre",
    "rem.overdueMany": "fatture non incassate oltre",
    "rem.days": "giorni",
    "rem.threshold": "Soglia giorni di ritardo",
    "rem.toneHint": "L'AI adatta il tono in base al ritardo: cordiale, fermo o formale.",
    "rem.delay": "Ritardo",
    "rem.aiReminder": "Sollecito AI",
    "rem.markPaid": "Pagata",
    "rem.paidToast": "segnata come pagata",
    "rem.empty": "Nessuna fattura in ritardo. Tutto incassato.",
    "rem.dialogTitle": "Sollecito per",
    "rem.daysLate": "giorni di ritardo",
    "rem.subject": "Oggetto",
    "rem.body": "Testo",
    "rem.copy": "Copia sollecito",
    "rem.copied": "Sollecito copiato",
    "rem.copyFailed": "Copia non riuscita: selezionalo e copialo a mano",
    "rem.failed": "Generazione non riuscita",

    "settings.title": "Dati per i documenti",
    "settings.subtitle": "Compaiono nell'intestazione di preventivi e fatture in PDF.",
    "settings.vat": "P. IVA / Tax ID",
    "settings.intlTitle": "Valuta e imposte",
    "settings.intlHint": "Usati nei PDF, nelle email e nelle bozze AI. Cambiali se lavori fuori dall'Italia.",
    "settings.currency": "Valuta dei documenti",
    "settings.defaultTax": "Aliquota predefinita %",
    "settings.taxLabel": "Etichetta imposta nei PDF",
    "settings.taxLabelHint": "Es. IVA, VAT, GST, Sales tax. Vuoto = automatica.",
    "settings.saved": "Dati aziendali aggiornati",
    "settings.language": "Lingua dell'interfaccia e dell'AI",

    "mail.send": "Invia per email",
    "mail.title": "Invia documento",
    "mail.to": "Destinatario",
    "mail.subject": "Oggetto",
    "mail.message": "Messaggio",
    "mail.attach": "Allega il PDF",
    "mail.sent": "Email inviata a",
    "mail.noEmail": "Il cliente non ha un indirizzo email",
    "mail.notConfigured": "Invio email non attivo: aggiungi la RESEND_API_KEY",
    "mail.sendReminder": "Invia sollecito",
    "logo.title": "Logo aziendale",
    "logo.hint": "PNG, JPG o WebP, max 3 MB. Compare in alto nei PDF.",
    "logo.upload": "Carica logo",
    "logo.remove": "Rimuovi",
    "logo.uploaded": "Logo aggiornato",
    "settings.iban": "IBAN (stampato sui documenti)",
    "settings.autoTitle": "Solleciti automatici",
    "settings.autoHint": "Ogni mattina controllo le fatture scadute: ti avviso e, se attivo, invio il sollecito al cliente.",
    "settings.autoToggle": "Invia i solleciti automaticamente",
    "settings.reminderDays": "Giorni di ritardo prima del sollecito",
    "notif.title": "Notifiche",
    "notif.empty": "Nessuna notifica.",
    "notif.checkNow": "Controlla adesso",
    "notif.checked": "Controllo completato",
    "dash.multiCurrency": "Il totale include piu valute:",
    "notif.overdueBy": "scaduta da",
    "notif.days": "giorni",
    "ai.title": "Operativo AI",
    "ai.subtitle": "Conosce clienti, documenti e attività",
    "ai.placeholder": "Scrivi una richiesta…",
    "ai.intro": "Chiedi qualcosa di operativo:",
    "ai.s1": "Cosa devo fare oggi per incassare più veloce?",
    "ai.s2": "Riassumi il lavoro svolto questa settimana",
    "ai.s3": "Quali preventivi devo ancora seguire?",
    "ai.connError": "Errore di connessione.",
  },

  en: {
    "brand.tagline": "AI assistant for quotes, invoices and daily work",
    "nav.dashboard": "Dashboard",
    "nav.quotes": "Quotes",
    "nav.invoices": "Invoices",
    "nav.reminders": "Reminders",
    "nav.recurring": "Recurring",
    "rec.hint":
      "Invoices that repeat are issued by Operativo on its own. Start from an invoice you already have: open the Invoices list and press the two-arrows icon.",
    "rec.empty": "No recurring invoices yet. Create one from an existing invoice:",
    "rec.frequency": "Every",
    "rec.next": "Next",
    "rec.count": "Issued",
    "rec.autoSend": "Send to client",
    "rec.runNow": "Issue now",
    "rec.pause": "Pause",
    "rec.resume": "Resume",
    "rec.issued": "Issued",
    "rec.deleted": "Recurring invoice removed",
    "rec.created": "Invoice set to repeat: I'll issue it for you",
    "rec.makeRecurring": "Make it recurring",
    "rec.weekly": "week",
    "rec.monthly": "month",
    "rec.quarterly": "quarter",
    "rec.yearly": "year",
    "wa.send": "Send on WhatsApp",
    "wa.message": "Here is the document",
    "imp.title": "Import from another software",
    "imp.hint":
      "Upload your XML e-invoices (a whole ZIP works too): I rebuild clients and history so you don't start from scratch.",
    "imp.choose": "Choose the XML or ZIP file",
    "imp.done": "Imported {n} invoices and {c} clients",
    "acc.title": "Your accountant",
    "acc.hint":
      "Every month I send them a single package with PDFs, XMLs and a summary of what you issued.",
    "acc.email": "Accountant email",
    "acc.day": "Day of the month",
    "acc.auto": "Send automatically every month",
    "acc.sendNow": "Send last month now",
    "acc.sent": "Sent {n} documents for {m}",
    "common.reload": "Reload",
    "nav.clients": "Clients",
    "nav.agenda": "Agenda",
    "nav.memory": "Memory",
    "nav.settings": "Settings",
    "nav.launch": "Launch",
    "nav.leadFinder": "Lead finder",
    "nav.admin": "Admin panel",
    "admin.title": "Control panel",
    "admin.subtitle": "Every number of the app, read-only. Only you can see this.",
    "admin.tab.overview": "Overview",
    "admin.tab.users": "Users",
    "admin.tab.reservations": "Reservations",
    "admin.tab.payments": "Payments",
    "admin.tab.usage": "Usage",
    "admin.users": "Registered users",
    "admin.last30": "in the last 30 days",
    "admin.active7": "active in 7 days",
    "admin.reserved": "Seats reserved",
    "admin.waitlist": "on the waitlist",
    "admin.revenue": "Total collected",
    "admin.aiMonth": "AI actions this month",
    "admin.documents": "Documents created",
    "admin.quotes": "Quotes",
    "admin.invoices": "invoices",
    "admin.clients": "Clients in the system",
    "admin.mode": "Sales mode",
    "admin.modePrebook": "Pre-launch",
    "admin.modeLive": "Payments live",
    "admin.emailOn": "Email configured",
    "admin.emailOff": "Email NOT configured",
    "admin.rows": "rows",
    "admin.exportCsv": "Export CSV",
    "admin.empty": "No data yet.",
    "admin.usage30": "Documents created in the last 30 days",
    "admin.notifyNote": "You get an instant email on every signup, reservation and payment.",
    "admin.funnel": "Conversion funnel (30 days)",
    "admin.chainTitle": "Where people drop off (30 days)",
    "admin.chainHint":
      "Each step shows how many people get through: the red bar is where you lose the most.",
    "admin.step.visitors": "Visitors",
    "admin.step.demo_view": "Scrolled to the demo",
    "admin.step.demo": "Tried the demo",
    "admin.step.memory_modal": "Saw the memory",
    "admin.step.emails": "Left their email",
    "admin.step.signups": "Created an account",
    "admin.step.activated": "Created a document",
    "admin.step.reserved": "Reserved a seat",
    "admin.ofPrev": "of previous step",
    "admin.lostHere": "people lost here",
    "admin.biggestDrop": "biggest drop",
    "admin.activation": "Actually using it",
    "admin.activationHint": "of accounts created at least one document",
    "admin.signupRate": "Signups",
    "admin.reserveRate": "Reservations",
    "admin.sources": "Where they come from (30 days)",
    "admin.sourcesHint":
      "Source of the first visit. Use links with ?utm_source=instagram to track campaigns.",
    "admin.noSources": "No source data yet.",
    "admin.visitors": "Unique visitors",
    "admin.views": "total visits",
    "admin.signups": "Signups",
    "admin.ofVisitors": "of visitors",
    "admin.today": "Today",
    "admin.col.email": "Email",
    "admin.col.plan": "Plan",
    "admin.col.docs": "Documents",
    "admin.col.ai": "AI month",
    "admin.col.seat": "Seat",
    "admin.col.created": "Signed up",
    "admin.col.lastLogin": "Last login",
    "admin.col.source": "Source",
    "admin.col.reserved": "Reserved on",
    "admin.col.converted": "Signed up on",
    "admin.col.product": "Product",
    "admin.col.amount": "Amount",
    "admin.col.status": "Status",
    "launch.title": "Launch dashboard",
    "launch.subtitle": "Waitlist, launch passes sold and AI usage this month. Only you can see this.",
    "launch.waitlist": "Waitlist signups",
    "launch.converted": "became users",
    "launch.passSold": "Launch passes sold",
    "launch.gross": "gross",
    "launch.proSubs": "Pro subscribers",
    "launch.users": "Registered users",
    "launch.aiActions": "AI actions this month",
    "launch.seats": "Launch offer seats",
    "launch.seatsHint": "seats left",
    "launch.months": "months",
    "launch.costs": "Your costs",
    "launch.error": "Only the account owner can see this data.",
    "launch.cost1": "App hosting on Emergent: 50 credits a month (~EUR 9.50), even with no users.",
    "launch.cost2": "Universal Key (AI): pay per use, ~EUR 0.30-1 per active user per month.",
    "launch.cost3": "Stripe: ~USD 1.75 on each USD 49.90 pass, ~USD 1.15 on each monthly Pro.",
    "nav.document": "Document",
    "nav.logout": "Log out",
    "nav.aiAssistant": "AI Assistant",

    "nav.plan": "Subscription",
    "plan.current": "Current plan",
    "plan.usage": "Documents created this month",
    "plan.docsMonth": "per month",
    "plan.trialing": "in free trial",
    "plan.renews": "Renews on",
    "plan.perMonth": "/ month",
    "plan.trial": "7-day free trial, then $14.90 per month. Cancel anytime.",
    "plan.afterPrice": "After the first 6 months: {price} per month, locked forever. Unlimited documents.",
    "plan.cta": "Start free trial",
    "plan.ctaYear": "Switch to yearly",
    "plan.year": "/ year",
    "plan.yearName": "Pro yearly",
    "plan.yearSave": "Save 28% compared to monthly.",
    "plan.active": "Subscription active. Thank you!",
    "plan.testCard": "Test: card 4242 4242 4242 4242, any future expiry, any CVC.",
    "plan.b1": "Unlimited quotes and invoices",
    "plan.b2": "PDFs with your logo and IBAN",
    "plan.b3": "AI assistant and drafts (fair use 300 actions/month on the launch pass, plus any bonus)",
    "plan.b4": "Automatic reminders and email sending",
    "plan.b5": "Revenue reports and CSV export",
    "plan.manage": "Manage or cancel subscription",
    "plan.founderBadge": "Launch offer",
    "plan.passName": "Launch pass · 6 months",
    "plan.passDesc": "One payment, 6 months of Operativo Pro. No auto-renewal: you decide when it ends.",
    "plan.passCta": "Get the launch pass",
    "plan.passActive": "launch pass active",
    "plan.passExpires": "Expires on",
    "plan.passDaysLeft": "days left",
    "plan.passNoRenewal": "No auto-renewal: nothing is charged when it ends and your account goes back to the Free plan.",
    "plan.prebookBadge": "Pre-launch · limited seats",
    "plan.prebookText": "Reserve your seat: you lock the $49.90 price for 6 months and +20 AI actions a month for life. You pay nothing today — we email you when payments open.",
    "plan.prebookNote": "Meanwhile the beta is free: unlimited documents and PDFs, 30 AI actions a month.",
    "plan.trialDaysLeft": "days left in your trial (everything unlocked, 100 AI actions)",
    "plan.reserveCta": "Reserve my seat",
    "plan.reserveDone": "Seat reserved! Price locked and AI bonus granted.",
    "plan.seatNo": "Seat",
    "plan.oneTime": "one-time · 6 months",
    "plan.seatsLeft": "seats left",
    "plan.soldOut": "Sold out",
    "plan.fairUse": "Fair use: 300 AI actions per month. Documents, PDFs and email stay unlimited.",
    "plan.guarantee": "30-day money-back guarantee.",
    "plan.proName": "Pro monthly",
    "plan.aiUsage": "AI actions used",
    "plan.aiMonth": "this month",
    "plan.waitlistBonus": "lifetime waitlist bonus",
    "plan.manageHint": "Opens the Stripe portal: payment methods, invoices and cancellation.",
    "pwa.title": "Install Operativo on your phone",
    "pwa.text": "One tap and the app sits on your home screen: quote jobs while you're on site.",
    "pwa.iosSteps": "On iPhone it takes 2 taps: open Safari's Share menu, then choose \"Add to Home Screen\".",
    "pwa.iosShare": "Share → Add to Home Screen",
    "pwa.settingsHint": "Install Operativo as an app on your phone or computer: it opens full screen, with no browser bar. On iPhone use Share → Add to Home Screen.",
    "pwa.cta": "Install",
    "pwa.later": "Later",
    "pay.checking": "Verifying your payment…",
    "pay.successTitle": "Payment complete",
    "pay.successText": "Pro is active: unlimited documents and all AI features.",
    "pay.pendingTitle": "Payment being verified",
    "pay.pendingText": "Still waiting for confirmation. If you completed the payment, your plan will activate shortly.",
    "pay.cancelTitle": "Payment cancelled",
    "pay.cancelText": "You have not been charged. You can try again anytime.",
    "pay.back": "Back to subscription",
    "nav.report": "Reports",
    "report.invoiced": "Invoiced",
    "report.collected": "Collected",
    "report.outstanding": "Outstanding",
    "report.byMonth": "Monthly trend",
    "report.month": "Month",
    "report.csv": "Export CSV",
    "common.loading": "Loading…",
    "common.save": "Save",
    "common.cancel": "Cancel",
    "common.delete": "Delete",
    "common.add": "Add",
    "common.search": "Search",
    "common.actions": "Actions",
    "common.status": "Status",
    "common.date": "Date",
    "common.due": "Due date",
    "common.total": "Total",
    "common.subtotal": "Subtotal",
    "common.notes": "Notes",
    "common.client": "Client",
    "common.number": "Number",
    "common.amount": "Amount",
    "common.email": "Email",
    "common.phone": "Phone",
    "common.address": "Address",
    "common.vatId": "VAT / Tax ID",

    "login.title": "Welcome back",
    "login.subtitle": "Sign in to pick up where you left off.",
    "login.submit": "Sign in",
    "login.noAccount": "Don't have an account?",
    "login.register": "Sign up",
    "login.password": "Password",
    "auth.heroTitle": "Quotes, invoices and organised days. Without wasting time.",
    "auth.heroText":
      "An AI assistant that knows your clients, remembers the work you've done and produces send-ready PDF documents.",
    "register.title": "Create your workspace",
    "register.subtitle": "Two minutes and your operational assistant is ready.",
    "register.name": "Full name",
    "register.company": "Company / Studio",
    "register.password": "Password (min 6 characters)",
    "register.submit": "Create account",
    "register.hasAccount": "Already have an account?",
    "register.login": "Sign in",

    "dash.revenue": "Invoiced revenue",
    "dash.pending": "Outstanding",
    "dash.openQuotes": "Open quotes",
    "dash.totalSuffix": "total",
    "dash.clients": "Clients",
    "dash.inRegistry": "in registry",
    "dash.tasksToday": "Today's tasks",
    "dash.completed": "completed",
    "dash.invoicesIssued": "Invoices issued",
    "dash.quickActions": "Quick actions",
    "dash.newQuote": "New quote",
    "dash.newInvoice": "New invoice",
    "dash.addClient": "Add client",
    "dash.planDay": "Plan my day",
    "time.title": "Time we saved you",
    "time.subtitle": "A conservative estimate, based on what you actually did in the app.",
    "time.thisMonth": "This month",
    "time.hours": "hours",
    "time.sixMonths": "Last 6 months",
    "time.each": "min each",
    "time.empty": "Nothing to count yet this month: create a document and come back.",
    "time.documents": "Quotes and invoices created",
    "time.ai_docs": "Written by AI (extra time)",
    "time.recurring": "Automatic recurring invoices",
    "time.xml": "E-invoices (XML)",
    "time.reminders": "Reminders sent",
    "time.notes": "Notes saved to memory",

    "dash.recentMemory": "Recent memory",
    "dash.seeAll": "See all",
    "dash.noActivity": "No activity recorded yet.",
    "dash.firstTitle": "You have no documents yet",
    "dash.firstText": "Describe a job you actually do and your first quote is ready in 20 seconds, line items and prices included.",
    "dash.firstCta": "Create your first quote",
    "admin.tab.feedback": "Feedback",
    "admin.feedbackTitle": "Why they didn't sign up",
    "admin.feedbackSent": "surveys sent",
    "admin.feedbackEmpty": "No survey answers yet.",
    "admin.col.received": "Received on",
    "admin.requestsTitle": "Requests from professionals",
    "dash.overdueOne": "invoice unpaid for over 30 days",
    "dash.overdueMany": "invoices unpaid for over 30 days",
    "dash.toRecover": "to recover",
    "dash.generateReminders": "Generate reminders with AI",

    "clients.searchPlaceholder": "Search client…",
    "clients.new": "New client",
    "clients.edit": "Edit client",
    "clients.name": "Company / Name",
    "clients.empty": "No clients in your registry.",
    "clients.created": "Client created",
    "clients.updated": "Client updated",
    "clients.deleted": "Client deleted",
    "clients.deleteTitle": "Delete this client?",
    "clients.deleteHint": "This cannot be undone. You are deleting",

    "docs.countQuotes": "quotes",
    "docs.countInvoices": "invoices",
    "docs.newQuote": "New quote",
    "docs.newInvoice": "New invoice",
    "docs.empty": "No documents yet. Create one or ask the AI assistant.",
    "docs.downloadPdf": "Download PDF",
    "docs.convert": "Convert to invoice",
    "docs.converted": "Invoice created",
    "docs.deleted": "Document deleted",
    "docs.type": "Type",
    "docs.quote": "Quote",
    "docs.invoice": "Invoice",
    "docs.creditNote": "Credit note",
    "docs.proforma": "Pro forma",
    "docs.receipt": "Receipt",
    "docs.makeCreditNote": "Create credit note",
    "docs.unit": "unit",
    "docs.discount": "Discount %",
    "docs.discountShort": "Disc. %",
    "docs.qty": "Qty",
    "docs.price": "Price",
    "docs.cassa": "Pension fund",
    "docs.taxable": "Taxable amount",
    "docs.withholding": "Withholding tax",
    "docs.stamp": "Stamp duty",
    "docs.netToPay": "Net to pay",
    "docs.fiscalTitle": "Professional taxes",
    "docs.cassaRate": "Fund %",
    "docs.withholdingRate": "Withholding %",
    "docs.withholdingOnCassa": "Apply withholding to the fund contribution too",
    "docs.refNumber": "Reference invoice",
    "settings.fiscalTitle": "Professional taxes",
    "settings.fiscalHint":
      "These values are pre-filled on every new document. Ask your accountant if unsure.",
    "settings.defaultCassa": "Default pension fund %",
    "settings.defaultWithholding": "Default withholding tax %",
    "settings.defaultStamp": "Default stamp duty",
    "settings.cassaType": "Pension fund",
    "settings.withholdingType": "Withholding type",
    "docs.freeClient": "— one-off client —",
    "docs.clientName": "Client name",
    "docs.items": "Line items",
    "docs.description": "Description",
    "docs.saveDoc": "Save document",
    "docs.updated": "Document updated",
    "docs.vatRate": "Tax %",
    "docs.aiTitle": "Generate with AI",
    "docs.aiHint": 'E.g. "Website redesign, 8 pages for Acme Ltd, with SEO and yearly hosting"',
    "docs.aiPlaceholder": "Describe the job…",
    "docs.aiFill": "Fill line items",
    "docs.aiDone": "Draft generated by AI",
    "docs.aiEmpty": "The AI returned no items. Try again with a more detailed description.",
    "docs.aiNeedBrief": "Describe the job to quote",

    "agenda.task": "Task",
    "agenda.taskPlaceholder": "E.g. Call Acme about the quote",
    "agenda.priority": "Priority",
    "agenda.high": "High",
    "agenda.medium": "Medium",
    "agenda.low": "Low",
    "agenda.minutes": "Minutes",
    "agenda.empty": "No tasks for this date.",
    "agenda.aiTitle": "AI day plan",
    "agenda.aiHint": "Orders tasks by impact on cash and deadlines.",
    "agenda.planNow": "Plan now",
    "agenda.planned": "Day planned",
    "agenda.planFailed": "Planning failed",

    "memory.notePlaceholder": "Log what you did: e.g. site visit at Acme, 2 hours",
    "memory.register": "Log it",
    "memory.searchPlaceholder": "Search your work memory…",
    "memory.empty": "Nothing in memory yet.",
    "memory.noteSaved": "Note saved to memory",
    "memory.all": "All",
    "memory.notes": "Notes",

    "rem.toRecover": "To recover",
    "rem.overdueOne": "invoice unpaid for over",
    "rem.overdueMany": "invoices unpaid for over",
    "rem.days": "days",
    "rem.threshold": "Overdue days threshold",
    "rem.toneHint": "The AI adapts the tone to the delay: friendly, firm or formal.",
    "rem.delay": "Overdue",
    "rem.aiReminder": "AI reminder",
    "rem.markPaid": "Paid",
    "rem.paidToast": "marked as paid",
    "rem.empty": "No overdue invoices. All collected.",
    "rem.dialogTitle": "Reminder for",
    "rem.daysLate": "days overdue",
    "rem.subject": "Subject",
    "rem.body": "Body",
    "rem.copy": "Copy reminder",
    "rem.copied": "Reminder copied",
    "rem.copyFailed": "Copy failed: select the text and copy it manually",
    "rem.failed": "Generation failed",

    "settings.title": "Details for your documents",
    "settings.subtitle": "They appear in the header of quotes and invoices in PDF.",
    "settings.vat": "VAT / Tax ID",
    "settings.intlTitle": "Currency and tax",
    "settings.intlHint": "Used in PDFs, emails and AI drafts. Change them if you work outside Italy.",
    "settings.currency": "Document currency",
    "settings.defaultTax": "Default tax rate %",
    "settings.taxLabel": "Tax label on PDFs",
    "settings.taxLabelHint": "E.g. VAT, GST, Sales tax, IVA. Empty = automatic.",
    "settings.saved": "Company details updated",
    "settings.language": "Interface and AI language",

    "mail.send": "Send by email",
    "mail.title": "Send document",
    "mail.to": "Recipient",
    "mail.subject": "Subject",
    "mail.message": "Message",
    "mail.attach": "Attach the PDF",
    "mail.sent": "Email sent to",
    "mail.noEmail": "This client has no email address",
    "mail.notConfigured": "Email sending is off: add RESEND_API_KEY",
    "mail.sendReminder": "Send reminder",
    "logo.title": "Company logo",
    "logo.hint": "PNG, JPG or WebP, max 3 MB. Shown at the top of your PDFs.",
    "logo.upload": "Upload logo",
    "logo.remove": "Remove",
    "logo.uploaded": "Logo updated",
    "settings.iban": "IBAN (printed on documents)",
    "settings.autoTitle": "Automatic reminders",
    "settings.autoHint": "Every morning I check overdue invoices: I notify you and, if enabled, email the reminder to the client.",
    "settings.autoToggle": "Send reminders automatically",
    "settings.reminderDays": "Overdue days before the reminder",
    "notif.title": "Notifications",
    "notif.empty": "No notifications.",
    "notif.checkNow": "Check now",
    "notif.checked": "Check completed",
    "dash.multiCurrency": "This total includes several currencies:",
    "notif.overdueBy": "overdue by",
    "notif.days": "days",
    "ai.title": "Operativo AI",
    "ai.subtitle": "Knows your clients, documents and tasks",
    "ai.placeholder": "Type a request…",
    "ai.intro": "Ask something operational:",
    "ai.s1": "What should I do today to get paid faster?",
    "ai.s2": "Summarise the work I did this week",
    "ai.s3": "Which quotes still need follow-up?",
    "ai.connError": "Connection error.",
  },
};

export const STATUS_LABELS = {
  it: {},
  en: {
    bozza: "draft",
    inviato: "sent",
    inviata: "sent",
    accettato: "accepted",
    rifiutato: "rejected",
    "da incassare": "unpaid",
    pagata: "paid",
    insoluta: "overdue",
    alta: "high",
    media: "medium",
    bassa: "low",
    quote: "quote",
    invoice: "invoice",
    credit_note: "credit note",
    proforma: "pro forma",
    receipt: "receipt",
    cliente: "client",
    task: "task",
    nota: "note",
    agenda: "agenda",
    sollecito: "reminder",
  },
};
